<template>
  <div
    :class="[$.context_body_multiselect]"
  >
    <div
      v-if="items.length > 15"
      :class="[$.context_body_search, 'multiselect_context']"
    >
      <div :class="[$.context_body_search_input]">
        <vgp-input
          v-model="searchStr"
          :style="{outline: '#fff'}"
          :class="'search-input'"
          :type="'text'"
          :placeholder="locale('search_projects_placeholder')"
          :icons-left="[
            { name: 'search' }]"
          :small="true"
          :select-by-focus="false"
        />
      </div>
    </div>
    <div
      :class="[$.multiselect_items, 'gantt_scroll', 'multiselect_context']"
    >
      <div
        v-for="item in visibleItems"
        :class="[
          $.menu_item,
          item.selected && !(item.isMultiselect && item.value !== 'empty') ? $.selected : '',
          item.selected ? 'selected_menu_item' : '',
          item.disabled ? $.disabled : '',
          item.divider ? $.divider : ''

        ]"
        :data-menu-type="`${item.type}:${item.menu}`"
        @click="selectItem(item)"
      >
        <div
          :class="$.item_content"
        >
          <div
            v-if="item.value !== 'empty'"
            :class="[$.checkbox, item.selected ? $.selected : '']"
          >
            <svg-sprite
              name="check"
              type="regular"
              :size="16"
              :style="{ color: '#FFFFFF' }"
            />
          </div>
          <div
            v-if="item.icon"
            :class="$.icon"
            :style="{
              background: item.isColorField ? item.name : ''
            }"
          >
            <img
              v-if="item.iconType === 'img'"
              :src="item.icon"
            >
            <svg-sprite
              v-else
              :name="item.icon"
              :type="item.iconType"
              :size="item.iconSize"
              :style="{ color: item.iconSelectedColor && item.selected ? item.iconSelectedColor : item.iconColor}"
            />
          </div>
          <div
            v-if="!item.isColorField"
            :class="[$.label, item.labelBg ? $.is_label_field : '' ]"
            :style="{
              color: item.labelColor || '',
              background: item.labelBg || ''
            }"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="multiselectChanges"
      :class="$.multiselect_submit"
    >
      <vgp-button
        :class="$.multiselect_submit_button"
        type="primary"
        small
        :label="locale('common_ok')"
        @onClick="submitMultiselect"
      />
    </div>
  </div>
</template>

<script>

export default {
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      locale: __,
      multiselectChanges: false,
      localSelected: [],
      searchStr: '',
    };
  },
  computed: {
    visibleItems() {
      return this.localSelected.filter(item => item.name.toLowerCase().includes(this.searchStr.toLowerCase()));
    }
  },
  watch: {
    items: {
      handler(val) {
        this.localSelected = val.map(item => ( {...item} ));
      },
      immediate: true,
    },

  },
  beforeDestroy() {
    this.localSelected = [];
    this.searchStr = '';
  },
  methods: {
    selectItem(item) {
      this.localSelected = this.localSelected.map(i => {
        if (item.value === 'empty') {
          i.selected = i.value === item.value;
        } else if (i.value === item.value) {
          i.selected = !i.selected;
        } else if (i.value === 'empty') {
          i.selected = false;
        }

        return i;
      });

      this.multiselectChanges = !_.isEqual(this.items, this.localSelected);
    },
    submitMultiselect() {
      const selectedValues = this.localSelected.filter(i => i.selected);

      this.$emit('selectItems', selectedValues);
    },
  },
};
</script>

<style module="$" src="../less/contextMenu.less"></style>
